import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import cn from "classnames";
import React, { useEffect, useState } from "react";
import { XBRimg, XbrWhite } from "../../../assets/index.js";

const TokenSelectionReceive = ({
  tokens,
  dropdownRef2,
  setIsOpen2,
  isOpen2,
  selectedToken2,
  selectedToken,
  newOnChangeSwapInputs,
  paletteMode,
  swapTokens,
  receiveValue,
  handleTokenChange,
  isIncreaseBalance,
}) => {

  return (
    <div>
      <form className="w-full relative">
        <label className="sr-only" htmlFor="token-input">
          Enter your number
        </label>
        <input
          id="token-input"
          autoComplete="off"
          className={`w-full h-[46px] pl-4 md:h-16 md:pl-6 
              dark:placeholder:text-lightWhite   
            ${
              paletteMode === "light"
                ? "bg-lightBlue placeholder:text-lightBlack"
                : "bg-darkButBg placeholder:text-lightWhite text-white"
            }  
          text-sm md:leading-6 md:text-base font-light
           uppercase text-black dark:text-white rounded-lg
           focus:outline-none`}
          type="text"
          placeholder={`00.00 ${selectedToken2.name}`}
          onWheel={(e) => e.preventDefault()}
          onChange={(e) => {
            const inputValue = e.target.value.replace(/[^0-9.]/g, "");
            newOnChangeSwapInputs(
              inputValue,
              selectedToken2.name,
              2,
              selectedToken.name
            );
          }}
          value={receiveValue}
        />
        <div className="flex gap-1 md:gap-2 absolute top-0 right-2 h-full items-center">
          <div className="relative" ref={dropdownRef2}>
            <button
              type={"button"}
              disabled={isIncreaseBalance}
              onClick={() => setIsOpen2(!isOpen2)}
              className={`h-[30px] md:h-10 justify-between ${
                isIncreaseBalance && "md:min-w-[106px] justify-сenter"
              } 
              ${paletteMode === "light" ? "bg-white" : "bg-darkCardBg"}
              flex items-center hover:bg-[#F0F4FF] active:bg-[#D8E2FF] transition-colors duration-300 text-black  px-2 md:px-4 py-3  dark:bg-darkCardBg dark:text-white rounded-lg shadow-selectionShadow gap-2 dark:hover:!bg-[#3C3A66]`}
            >
              <div className="flex items-center justify-center md:gap-2">
                <img
                  src={
                    selectedToken2.name === "XBR"
                      ? paletteMode === "light"
                        ? XbrWhite
                        : XBRimg
                      : selectedToken2.image
                  }
                  alt={selectedToken2.name}
                  className="w-[20px] h-[20px] md:w-7 md:h-7 object-cover"
                />
                <span
                  className={`hidden md:block ${
                    paletteMode === "light" ? "text-[#000]" : "text-[#fff]"
                  } text-sm font-medium leading-[21px]`}
                >
                  {selectedToken2.name}
                </span>
              </div>
              {!isIncreaseBalance &&
                (isOpen2 ? (
                  <ChevronUpIcon className="w-[14px] h-[14px] md:w-5 md:h-5  fill-black dark:fill-white" />
                ) : (
                  <ChevronDownIcon className="w-[14px] h-[14px] md:w-5 md:h-5  ifll-black dark:fill-white" />
                ))}
            </button>
            {isOpen2 && (
              <div
                className={
                  "absolute w-full mt-1 shadow-selectionShadow bg-white border border-gray-300 dark:bg-darkCardBg rounded-xl z-50"
                }
              >
                {tokens.map((currency) => (
                  <div
                    key={currency.id}
                    className={cn(
                      "px-1 md:px-4 rounded-xl py-1 rounded-[4px] flex items-center gap-1 md:gap-2 cursor-pointer hover:bg-[#F6F9FF] active:bg-[#D8E2FF] transition-colors duration-300 dark:hover:!bg-[#3C3A66]"
                    )}
                    onClick={() => {
                      if (currency.id === selectedToken.id) {
                        swapTokens(2);
                      } else {
                        handleTokenChange(currency, false);
                      }
                      setIsOpen2(false);
                    }}
                  >
                    <img
                      src={currency.image}
                      alt={currency.name}
                      className="w-[20px] h-[20px] md:w-7 md:h-7 object-cover"
                    />
                    <span className="text-[10px] text-black dark:text-white md:text-sm font-medium leading-[21px]">
                      {currency.name}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default TokenSelectionReceive;
